import React from 'react';
import { LineChart } from '../../components/Charts/Line';
import { ChartsContent, DashContainer } from './styles';
import { ComparativeCardComp } from '../../components/Cards/ComparativeCard';
import { Box, Grid } from '@mui/material';
import { CardLine } from '../../components/Cards/ComparativeCardLine/CardLine';
import {
  SelectOptionsMock,
  SelectOptionsMockSSE,
  SelectOptionsMockUsuarios,
  SelectOptionsSASMock,
  SelectOptionsUsuariosMock,
  mockCategories,
  mockSeries,
} from '../../components/Charts/Line/chartDataMocks';
import { useTotalDashAcessos } from './hooks/acessos';
import { useTotalDashAtendimentosSSE } from './hooks/atendimentosSse';
import { useTotalDashRegistroSas } from './hooks/registroSas';
import { useTotalDashUsuarios } from './hooks/usuarios';
import { useFilters } from '../../../context/filters';
import { LoadingLineChart } from '../../components/Charts/Line/loadingLineChart';
import { SEText } from '../../components/SEText';

const Dashboard = () => {
  const {
    dashAcessosFilter,
    dashRegistroSasFilter,
    dashAtendSseFilter,
    dashUsuariosFilter,
  } = useFilters();

  const { data: dataAcessos, isLoading: isLoadingAcessos } =
    useTotalDashAcessos(dashAcessosFilter);
  const { data: dataAtendSse, isLoading: isLoadingAtendSse } =
    useTotalDashAtendimentosSSE(dashAtendSseFilter);
  const { data: dataRegistroSas, isLoading: isLoadingRegistroSas } =
    useTotalDashRegistroSas(dashRegistroSasFilter, 'line');
  const { data: dataUsuarios, isLoading: isLoadingUsuarios } =
    useTotalDashUsuarios(dashUsuariosFilter);

  return (
    <div className="layout-container">
      <div className="layout-title">
        <Box paddingY={2}>
          <SEText type="title">Início</SEText>
        </Box>
      </div>
      <DashContainer>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <CardLine />
          </Grid>

          <Grid item xs={8}>
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid item xs={6}>
                <ComparativeCardComp title={'Diagnóstico'} />
              </Grid>
              <Grid item xs={6}>
                <ComparativeCardComp title={'Registro SAS'} />
              </Grid>
              <Grid item xs={6}>
                <ComparativeCardComp title={'Atendimentos SSE'} />
              </Grid>
              <Grid item xs={6}>
                <ComparativeCardComp title={'Usuários'} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <ChartsContent>
          {isLoadingAcessos ? (
            <LoadingLineChart height="20rem" />
          ) : (
            <LineChart
              title="acessos"
              type="line"
              total={dataAcessos?.total}
              series={dataAcessos?.series}
              categories={dataAcessos?.categories}
              selectOptions={SelectOptionsMock}
              seeMore={() => alert('Working!')}
              filterLabel="acessos"
            />
          )}

          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid item xs={6}>
              <LineChart
                title="diagnósticos"
                type="area"
                total={223547}
                series={mockSeries}
                categories={mockCategories}
                selectOptions={SelectOptionsMockUsuarios}
                seeMore={() => alert('Working!')}
                filterLabel="acessos"
              />
            </Grid>

            <Grid item xs={6}>
              {isLoadingRegistroSas ? (
                <LoadingLineChart />
              ) : (
                <LineChart
                  title="registro SAS"
                  type="line"
                  total={dataRegistroSas?.total}
                  series={dataRegistroSas?.series}
                  categories={dataRegistroSas?.categories}
                  selectOptions={SelectOptionsSASMock}
                  seeMore={() => alert('Working!')}
                  filterLabel="sas"
                />
              )}
            </Grid>

            <Grid item xs={6}>
              {isLoadingAtendSse ? (
                <LoadingLineChart />
              ) : (
                <LineChart
                  title="atendimentos SSE"
                  type="line"
                  total={dataAtendSse.total}
                  series={dataAtendSse.series}
                  categories={dataAtendSse.categories}
                  selectOptions={SelectOptionsMockSSE}
                  seeMore={() => alert('Working!')}
                  filterLabel="sse"
                />
              )}
            </Grid>

            <Grid item xs={6}>
              {isLoadingUsuarios ? (
                <LoadingLineChart />
              ) : (
                <LineChart
                  title="usuários"
                  type="line"
                  total={dataUsuarios.total}
                  series={dataUsuarios.series}
                  categories={dataUsuarios.categories}
                  selectOptions={SelectOptionsUsuariosMock}
                  seeMore={() => alert('Working!')}
                  filterLabel="usuarios"
                />
              )}
            </Grid>
          </Grid>
        </ChartsContent>
      </DashContainer>
    </div>
  );
};

export default Dashboard;
